import { useQuery } from "@tanstack/react-query";
import { Building2, CalendarDays, Home, Tent } from "lucide-react";
import api from "@/lib/api";
import { CenterCalendar } from "@/components/enhancer/CenterCalendar";
import CenterMembershipPanel from "@/components/enhancer/CenterMembershipPanel";
import VenuePanel from "@/components/enhancer/VenuePanel";
import { EnhancerReferralOffers } from "@/components/ReferralAgreements";

export const CS_VIEWS = [["calendar", "Center calendars", CalendarDays], ["centers", "My centers", Building2], ["rooms", "Rooms & retreats", Tent], ["spaces", "My own spaces", Home]];

// One home for centers, their calendars, room/retreat booking and the enhancer's own spaces.
export const CentersSchedulePanel = ({ view, setView, spacesPanel }) => {
  const { data: centers = [], isLoading } = useQuery({ queryKey: ["enh-centers"], queryFn: () => api.get("/enhancer/centers").then((r) => r.data) });
  const approved = centers.filter((c) => c.status === "approved");
  const go = (k) => {
    setView(k);
    const q = new URLSearchParams(window.location.search);
    q.set("tab", "Centers & Schedule"); q.set("view", k);
    window.history.replaceState(null, "", `${window.location.pathname}?${q}`);
  };
  return (
    <div data-testid="enh-centers-schedule">
      <h2 className="font-serif text-2xl text-[#1A242B] mb-1">Centers & Schedule</h2>
      <p className="text-sm text-[#4A5D6B] mb-5">See each center's rooms next to your own schedule and book open time yourself.</p>
      <div className="flex flex-wrap gap-2 mb-6" role="tablist">
        {CS_VIEWS.map(([k, l, Icon]) => (
          <button key={k} role="tab" aria-selected={view === k} onClick={() => go(k)} data-testid={`cs-view-${k}`}
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm transition-colors ${view === k ? "bg-[#144F75] text-white" : "bg-white border border-[#E5E0D8] text-[#4A5D6B] hover:border-[#144F75]"}`}>
            <Icon size={14} /> {l}
          </button>
        ))}
      </div>
      {view === "calendar" && (isLoading ? null : approved.length ? <CenterCalendar centers={approved} /> : (
        <div className="eyw-card p-6" data-testid="cs-no-centers">
          <p className="text-[#1A242B]">You're not approved at a center yet.</p>
          <button onClick={() => go("centers")} className="eyw-btn !py-2 text-sm mt-3" data-testid="cs-apply-centers">Apply to a center</button>
        </div>
      ))}
      {view === "centers" && <><EnhancerReferralOffers /><CenterMembershipPanel /></>}
      {view === "rooms" && <VenuePanel />}
      {view === "spaces" && spacesPanel}
    </div>
  );
};
